import { connect } from 'react-redux';
import DashboardActionPanel from '../../OutstandingView/dashboardActions/DashboardActionPanel';
import { Dispatch } from 'redux';
import { API_GET_ACCOUNTS_SUCCESS } from '@api/lendingAPI/LendingAPI.actions';
import { useQuery } from '@tanstack/react-query';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { GetAccountsResponse } from '@iwoca/lapi-client/edge';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    syncReduxStore: (accountsResponse: GetAccountsResponse) => {
        dispatch({
            type: API_GET_ACCOUNTS_SUCCESS,
            response: accountsResponse
        });
    }
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const DrawdownPanel = ({ syncReduxStore }: PropsFromRedux) => {
    const stateKey = useStateKey();

    const { data: accountsResponse, isLoading } = useQuery(
        getAccountsQueryConfig(stateKey)
    );

    if (isLoading) return null;

    syncReduxStore(accountsResponse!);

    return (
        <DashboardActionPanel activeDashboardAction="top-up-drawdown-action" />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(DrawdownPanel);
